import CustomForm from "../CustomForm";
import DragCell from "../shared/components/FormCell/DragCell";

export default abstract class DragDrop extends CustomForm {

    protected readonly dragCells: DragCell[] = [];

    public rewriteFormControls() {
        return true;
    }

}

